import React from "react";
import DocumentDetailBox from "./documentDetailBox";
import "./admissionDocuments.scss";

const DuringTreatmentDocuments = ({ DURINGTREATMENTDOCUMENT }) => {
  let documents = DURINGTREATMENTDOCUMENT;

  return (
    <div className="update-document-box">
      <div className="heading">
        Enhancement Document {/* <MapDocumentModal/> */}
      </div>
      <hr className="line" />
      <div className="sub-container">
        {documents && documents.length > 0 ? (
          documents.map((document, idx) => {
            return (
              <DocumentDetailBox
                key={idx}
                docDetails={document}
                siblingDocuments={documents} // Pass all documents
              />
            );
          })
        ) : (
          <div className="sub-heading">No document mapped</div>
        )}
      </div>
    </div>
  );
};

export default DuringTreatmentDocuments;
